/**
 * 流程中心
 */
// import { Vue } from 'vue-property-decorator';
export var SelectKeysMapping;
(function (SelectKeysMapping) {
    SelectKeysMapping[SelectKeysMapping["MyUnfinishedWorkItem"] = 1] = "MyUnfinishedWorkItem";
    SelectKeysMapping[SelectKeysMapping["MyUnReadWorkItem"] = 2] = "MyUnReadWorkItem";
    SelectKeysMapping[SelectKeysMapping["MyFinishedWorkItem"] = 3] = "MyFinishedWorkItem";
    SelectKeysMapping[SelectKeysMapping["MyReadWorkItem"] = 4] = "MyReadWorkItem";
    SelectKeysMapping[SelectKeysMapping["MyWorkflow"] = 5] = "MyWorkflow";
    SelectKeysMapping[SelectKeysMapping["QueryInstance"] = 6] = "QueryInstance";
    SelectKeysMapping[SelectKeysMapping["QueryParticipantWorkItem"] = 7] = "QueryParticipantWorkItem";
    SelectKeysMapping[SelectKeysMapping["MyComments"] = 8] = "MyComments";
    SelectKeysMapping[SelectKeysMapping["DelegationWorkflow"] = 9] = "DelegationWorkflow";
})(SelectKeysMapping || (SelectKeysMapping = {}));
// 超时
export var WorkItemTimeoutStatus;
(function (WorkItemTimeoutStatus) {
    WorkItemTimeoutStatus["TIMEOUT"] = "TIMEOUT";
    WorkItemTimeoutStatus["RED"] = "RED";
    WorkItemTimeoutStatus["ORANGE"] = "ORANGE";
    WorkItemTimeoutStatus["NORMAL"] = "NORMAL";
})(WorkItemTimeoutStatus || (WorkItemTimeoutStatus = {}));
// 已读标识
export var WorkItemStatus;
(function (WorkItemStatus) {
    WorkItemStatus[WorkItemStatus["NOTSTART"] = 1] = "NOTSTART";
    WorkItemStatus[WorkItemStatus["INPROGESS"] = 2] = "INPROGESS";
})(WorkItemStatus || (WorkItemStatus = {}));
export var WorkflowInstanceState;
(function (WorkflowInstanceState) {
    WorkflowInstanceState["DRAFT"] = "DRAFT";
    WorkflowInstanceState["PROCESSING"] = "PROCESSING";
    WorkflowInstanceState["COMPLETED"] = "COMPLETED";
    WorkflowInstanceState["CANCELED"] = "CANCELED";
    WorkflowInstanceState["EXCEPTION"] = "EXCEPTION";
})(WorkflowInstanceState || (WorkflowInstanceState = {}));
export var ApprovalState;
(function (ApprovalState) {
    ApprovalState[ApprovalState["AGREE"] = 1] = "AGREE";
    ApprovalState[ApprovalState["REJECT"] = 2] = "REJECT";
    ApprovalState[ApprovalState["FORWARD"] = 3] = "FORWARD";
    ApprovalState[ApprovalState["CANCELLED"] = 4] = "CANCELLED";
    ApprovalState[ApprovalState["UNDO"] = 5] = "UNDO";
})(ApprovalState || (ApprovalState = {}));
/**
 * 路由名称
 */
export var WorkflowCenterRouter;
(function (WorkflowCenterRouter) {
    WorkflowCenterRouter["MyUnfinishedWorkItem"] = "myUnfinishedWorkItem";
    WorkflowCenterRouter["StartWorkflow"] = "startWorkflow";
    WorkflowCenterRouter["MyUnReadWorkItem"] = "myUnReadWorkItem";
    WorkflowCenterRouter["MyFinishedWorkItem"] = "myFinishedWorkItem";
    WorkflowCenterRouter["MyReadWorkItem"] = "myReadWorkItem";
    WorkflowCenterRouter["MyWorkflow"] = "myWorkflow";
    WorkflowCenterRouter["QueryInstance"] = "queryInstance";
    WorkflowCenterRouter["QueryParticipantWorkItem"] = "queryParticipantWorkItem";
})(WorkflowCenterRouter || (WorkflowCenterRouter = {}));
/**
 * 计算表格最大高度的类型
 */
export var CalculateMaxHeightTypes;
(function (CalculateMaxHeightTypes) {
    CalculateMaxHeightTypes["OnlyTable"] = "onlyTable";
    CalculateMaxHeightTypes["HasBtns"] = "hasBtns";
    CalculateMaxHeightTypes["HasFilters"] = "hasFilters";
    CalculateMaxHeightTypes["HasTabsAndFilters"] = "hasTabsAndFilters"; // 有过滤条件和tab切换
})(CalculateMaxHeightTypes || (CalculateMaxHeightTypes = {}));
